export enum SimulationState {
  EN_ATTENTE = "PENDING",
  VALIDEE = "VALIDATED",
  ANNULEE = "CANCELED",
}
